import { useEffect, useState } from 'react';
import { get } from '../../../Services/api'
import yyyy_mm_dd_date_format from '../../../Utility/yyyy_mm_dd_date_format';
import WaterHistoryChart from './Chart';

function DashboardWaterHistory({ currentUser, update_history }) {
    const i_date = yyyy_mm_dd_date_format({})
    const days_week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

    const [weekDates, setWeekDates] = useState([]);
    const [waterHistoryEndTime, setWaterHistoryEndTime] = useState(i_date);
    const [details, setDetails] = useState([])
    const [nextButtonBold, setNextButtonBold] = useState()
    const waterHistoryTimeFrame = 7

    useEffect(() => {
        // get week days
        getWaterHistoryDates()
    }, [waterHistoryEndTime, update_history])

    useEffect(() => {
        // Last week water consumption
        get_water_consumption_history()
    }, [weekDates])

    function getWaterHistoryDates() {
        const dates = [];
        // Loop from time_frame days before end_date to end_date
        for (let i = waterHistoryTimeFrame - 1; i >= 0; i--) {
            const date = yyyy_mm_dd_date_format({ i_date: waterHistoryEndTime, sub_days: i })
            const date_utc = new Date(date + "T00:00:00Z");

            dates.push({
                day_of_week: days_week[date_utc.getUTCDay()],
                date: date
            }); // Add to dates array
        }

        setWeekDates(dates)
    }

    async function get_water_consumption_history() {
        try {
            const userWaterConsumptionHistory = await get("/api/water/user-water-history", {
                user_id: currentUser.uid,
                n_days: waterHistoryTimeFrame,
                end_date: waterHistoryEndTime
            })
            dataChartFormat(userWaterConsumptionHistory)
        } catch (error) {
            dataChartFormat([])
            console.log(error)
        }
    }


    function dataChartFormat(data) {
        getWeekDetail(data)
    }

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    function date_to_month_day(date) {
        const date_split = date.split('-')
        return months[parseInt(date_split[1]) - 1] + ' ' + date_split[2]
    }

    // get graph ready array for 7 days
    function getWeekDetail(data) {
        let result = [];

        // Create a dictionary to store data by date for faster access
        const dataByDate = data.reduce((acc, dayIntake) => {
            acc[dayIntake.date] = parseInt(dayIntake.amount, 10);
            return acc;
        }, {});

        weekDates.forEach((day) => {
            const amount = dataByDate[day.date] || 0;  // default to 0 if date not found

            result.push({
                label: i_date === waterHistoryEndTime ? day.day_of_week : date_to_month_day(day.date),
                data: {
                    amount: amount,
                }
            });
        });

        if (result && result.length > 0) {
            setDetails(result);
        }
    }


    function historyChangeRange(back) {
        if (back) {
            const end_date = yyyy_mm_dd_date_format({ i_date: waterHistoryEndTime, sub_days: waterHistoryTimeFrame })
            setWaterHistoryEndTime(end_date)
        } else {
            const end_date = yyyy_mm_dd_date_format({ i_date: waterHistoryEndTime, add_days: waterHistoryTimeFrame })
            setWaterHistoryEndTime(end_date)
            if (end_date >= i_date)
                setNextButtonBold()
        }
    }

    return (
        <div className='component_padding black'>
            <div className='dashboard-intake-overview-heading flex align_center justify_space_between'>
                <h4 className='font_family_ovo no_margin'>Water Intake</h4>

                <div className="dashboard-intake-overview-range-picker-div">
                    <div className='flex gap_12 align_center'>
                        <div onMouseEnter={() => setNextButtonBold(false)} onMouseLeave={() => setNextButtonBold()} className={(nextButtonBold === false ? 'dashboard-upcoming-meal-calendar-button-half-circle' : 'dashboard-upcoming-meal-calendar-button-full-circle') + ' flex align_center justify_center cursor_pointer'} onClick={() => historyChangeRange(true)}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path d="M11 15L5 9L11 3" stroke="url(#paint0_linear_1_2093)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <defs>
                                    <linearGradient id="paint0_linear_1_2093" x1="14" y1="11.625" x2="10.7448" y2="1.13302" gradientUnits="userSpaceOnUse">
                                        <stop stopColor="#235539" />
                                        <stop offset="1" stopColor="#7B946B" />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                        <div className={(nextButtonBold ? 'dashboard-upcoming-meal-calendar-button-half-circle' : 'dashboard-upcoming-meal-calendar-button-full-circle')
                            + (waterHistoryEndTime < i_date ? ' cursor_pointer' : '') + ' flex align_center justify_center'}
                            onMouseEnter={() => { if (waterHistoryEndTime < i_date) setNextButtonBold(true) }} onMouseLeave={() => setNextButtonBold()} onClick={() => { if (waterHistoryEndTime < i_date) historyChangeRange(false) }}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path d="M7 15L13 9L7 3" stroke="url(#paint0_linear_1_2096)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <defs>
                                    <linearGradient id="paint0_linear_1_2096" x1="4" y1="11.625" x2="7.25521" y2="1.13302" gradientUnits="userSpaceOnUse">
                                        <stop stopColor="#235539" />
                                        <stop offset="1" stopColor="#7B946B" />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            <div className='component_heading_separating_line'></div>

            <WaterHistoryChart details={details} />
        </div>
    );
}


export default DashboardWaterHistory;